import { Box, Stack, Typography } from '@mui/material'
import { RatingType } from '../../../components/matchmaking/ChallengeCard'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'
import StatsContainer from '../../Profile/components/StatsContainer'
import StatsTable from '../../Profile/components/StatsTable'

// utter junk code to make stats workable
export const StatsWrapper = () => {
    const { isMobile } = useScreenSize()
    const ratingTypes: RatingType[] = ['bullet', 'blitz', 'rapid', 'classic']

    if (isMobile) {
        return (
            <Stack
                sx={{
                    gap: 1,
                    width: '100%',
                    'div, li': {
                        borderRadius: '0px',
                        margin: 0,
                    },
                    li: {
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                    },
                }}
            >
                <Typography textTransform="uppercase" variant="h4" sx={{ borderBottom: '2px solid white', pb: 1 }}>
                    Stats
                </Typography>
                {ratingTypes.map((ratingType, index) => (
                    <StatsContainer key={index} ratingType={ratingType} />
                ))}
            </Stack>
        )
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Typography textTransform="uppercase" variant="h4" sx={{ borderBottom: '2px solid white', pb: 1 }}>
                Stats
            </Typography>
            <StatsTable />
        </Box>
    )
}
